import extractApiData from 'Helpers/extractApiData'
import apiWrapper from 'Helpers/apiWrapper'

const endpoints = (baseURL => {
  return {
    getSmsSendingDetails: idSending =>
      `${baseURL}/api/sms/sending/${idSending}/details`
  }
})(process.env.BEMESSEND_URL)

export const beMessSendApiGetSmsSendingDetails = idSending => {
  const url = endpoints.getSmsSendingDetails(idSending)

  return apiWrapper({
    method: 'get',
    url: url
  }).then(extractApiData)
}
